import { Link } from 'react-router-dom';

const LINK_GROUPS = [
  {
    title: '内容导航',
    links: [
      { label: '漫画分类', to: '/category/comics' },
      { label: '动漫资讯', to: '/category/news' },
      { label: '作品排行榜', to: '/category/comics?sort=popularity' },
      { label: '热门专题', to: '/#topics' },
    ],
  },
  {
    title: '热门类型',
    links: [
      { label: '热血少年', to: '/category/comics?genre=热血' },
      { label: '治愈日常', to: '/category/comics?genre=日常' },
      { label: '奇幻冒险', to: '/category/comics?genre=奇幻' },
      { label: '恋爱青春', to: '/category/comics?genre=恋爱' },
    ],
  },
  {
    title: '关于漫蛙',
    links: [
      { label: '站点介绍', to: '/#about' },
      { label: '友情链接', to: '/#about' },
      { label: '联系方式', to: '/#about' },
      { label: '版权说明', to: '/#about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="mb-4 flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className="ri-leaf-line" />
              </span>
              <span className="font-heading text-xl font-800 text-background-50">漫蛙</span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-secondary-200/90">
              漫蛙漫画动漫频道，专注为动漫爱好者提供最新动漫资讯与优质漫画作品推荐，发现属于你的下一部心头好。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900 text-base text-secondary-100"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>

          {LINK_GROUPS.map((group) => (
            <div key={group.title}>
              <h3 className="mb-4 font-heading text-sm font-700 tracking-wide text-background-50">{group.title}</h3>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-sm text-secondary-200/90 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-300">
            © 2026 漫蛙 MANWA · 本网站内容均为演示数据，仅供产品展示使用
          </p>
          <p className="text-xs text-secondary-300">
            合作与投稿：hello@manwa-demo.com
          </p>
        </div>
      </div>
    </footer>
  );
}